module.exports = __webpack_public_path__ + "static/media/logo-maurys.d9d43500.jpg";